function normalizeFromToValue(value) {
    const { firstInput, secondInput } = value;

    if (null !== secondInput) {
        return secondInput;
    }

    if (null !== firstInput) {
        return firstInput;
    }

    return null;
}

export const normalizeStep = (values) => {
    const { bags, from, to, fromStep, toStep, departureLodgingInformation, arrivalLodgingInformation } = values;

    return {
        ...values,
        from: from ? from : {
            step : {
                ...fromStep,
                comment: departureLodgingInformation
            },
            stop: null,
            locality : null
        },
        to: to ? to : {
            step : {
                ...toStep,
                comment: arrivalLodgingInformation
            },
            stop: null,
            locality : null
        },
        bags: parseInt(bags)
    };
};
